// removed by extract-text-webpack-plugin
module.exports = {"container":"_2YslPFAq7SBkEr79mAeBRR","Email":"_39dnDAUhx_aqZSp3QQdQvq","Signer":"_8AwKugd4Uh08PV8z1qIlK","Icon":"_33XZl2rNaz7k7LRK6wGD2C","Title":"_2RzR97DjmnYv10DQU-4omh"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/DocumentVerify/Main/Verify/BioSigners/styles.css
// module id = 3011
// module chunks = 0